import React from "react";
import { useLogin } from "@pankod/refine-core";
import {
    Row,
    Col,
    AntdLayout,
    Card,
    Typography,
    Form,
    Input,
    Button,
    Checkbox,
} from "@pankod/refine-antd";

const { Text, Title } = Typography;

export interface ILoginForm {
    username: string;
    password: string;
    remember: boolean;
}

export const Login: React.FC = () => {
    const [form] = Form.useForm<ILoginForm>();

    const { mutate: login } = useLogin<ILoginForm>();

    const CardTitle = (
        <>
            <Title level={3} className="title" style={{ color: '#134987' }}>
                Iniciar de Sesión
            </Title>
            <Text className="subtitle">
                Ingrese sus credenciales
            </Text>
        </>
    );

    return (
        <AntdLayout className="layout">
            <Row
                justify="center"
                align="middle"
                style={{
                    height: "100vh",
                }}
            >
                <Col xs={22}>
                    <div className="container">
                        <div className="imageContainer">
                            <img src="/images/uas-logos.png" alt="UAS" />
                        </div>
                        <Title level={3} className="title" style={{ color: 'white', fontWeight: 'normal' }}>
                            Universidad Autónoma de Sinaloa<br />Unidad Regional Sur<br />
                        </Title>
                        <Card title={CardTitle} headStyle={{ borderBottom: 0 }}>
                            <Form<ILoginForm>
                                layout="vertical"
                                form={form}
                                onFinish={(values) => {
                                    login(values);
                                }}
                                requiredMark={false}
                                initialValues={{
                                    remember: false,
                                }}
                            >
                                <Form.Item
                                    name="username"
                                    label="Usuario"
                                    rules={[{ required: true }]}
                                >
                                    <Input
                                        size="large"
                                        placeholder="Usuario"
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    label="Contraseña"
                                    rules={[{ required: true }]}
                                    style={{ marginBottom: "12px" }}
                                >
                                    <Input
                                        type="password"
                                        placeholder="●●●●●●●●"
                                        size="large"
                                    />
                                </Form.Item>
                                {/*
                                <div style={{ marginBottom: "12px" }}>
                                    <Form.Item
                                        name="remember"
                                        valuePropName="checked"
                                        noStyle
                                    >
                                        <Checkbox
                                            style={{
                                                fontSize: "12px",
                                            }}
                                        >
                                            Recordarme
                                        </Checkbox>
                                    </Form.Item>
                                    <a
                                        style={{
                                            float: "right",
                                            fontSize: "12px",
                                        }}
                                        href="#"
                                    >
                                        Forgot password?
                                    </a>
                                </div>
                                */}
                                <Button
                                    type="primary"
                                    size="large"
                                    htmlType="submit"
                                    block
                                    className="login__button"
                                >
                                    Iniciar Sesión
                                </Button>
                            </Form>
                        </Card>
                    </div>
                    <Text className="copyright" style={{marginTop: '15px'}}>
                        Copyright © 2025 Universidad Autónoma de Sinaloa<br />
                        Desarrollado por Unidad Regional Sur
                    </Text>
                </Col>
            </Row>
        </AntdLayout>
    );
};